import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ClientssoService } from 'src/app/common/services/clientsso.service';

@Component({
  selector: 'app-external-sso',
  templateUrl: './external-sso.component.html',
  styleUrls: ['./external-sso.component.css'],
})
export class ExternalSSOComponent {
  constructor(
    private clientSsoService: ClientssoService,
    private route: ActivatedRoute,
    private authService: ClientssoService,
  ) {}

  ngOnInit() {
    const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
    //this.authService.handleAuthCallback();

    this.clientSsoService.loginWithOkta();
  }

  private normalizeReturnPath(returnUrl: string | null): string {
    if (!returnUrl) {
      return '/landing';
    }

    if (returnUrl.startsWith('/')) {
      return returnUrl;
    }

    return `/${returnUrl}`;
  }
}
